<template>
    <div
        class="progress-circle"
        role="progressbar"
        :aria-valuenow="progress"
        aria-valuemin="0"
        aria-valuemax="100"
        :aria-valuetext="content ?? `${Math.round(progress)}% complete`"
        :data-content="content ?? `${Math.round(progress)}%`">
        <slot></slot>
    </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

type ProgressCircleProps = {
    progress?: number;
    content?: string;
    gradientFrom?: string;
    gradientTo?: string;
};

const { progress = 0, content, gradientFrom = "#2ab756", gradientTo = "#b7eb8f" } = defineProps<ProgressCircleProps>();

const progressString = computed(() => `${progress}%`);
</script>

<style scoped>
@reference "../../../css/tailwind.css";

div.progress-circle {
    @apply w-full h-full rounded-full flex text-black;
    transition: all 0.3s;
    background: conic-gradient(v-bind(gradientFrom) v-bind(progressString), v-bind(gradientTo) 0deg);
}

div.progress-circle::after {
    @apply details font-medium flex flex-col justify-center w-full rounded-full bg-white text-center;
    content: attr(data-content);
    margin: 5px;
}
</style>
